// 默认 页面 加载完成后会主动 发送 pageEnter 配置一些页面需要自定义处理
const NOT_AUTO_TO_LIST = [
  'page_pgc_article_detail', // 资讯详情
  'page_search_result_new', // 搜索
  'page_my_collection', // 收藏页面
  'page_personal_homepage', // 个人主页
  'page_car_model_comparison', // 车型对比
  'page_car_zonghe_comparison', // 综合对比
  'page_feed_article_mix_static', // 资讯静态化
  'page_ugc_detail', // ugc详情页
  'page_answer_detail', // ugc详情页
  'page_reputation_detail', // 口碑详情页
  'page_car_series_dcd_score_home', // 懂车分主页
  'page_ugc_forum_home', //车友圈详情
  'page_topic_talk_details', // 话题详情
  'page_car_style_home', // 车型页
  'page_price_calculator', // 价格计算器
  'page_dcd_list', // 排行榜
  'page_video_combine_pc', // 视频频道
]

const cusPageEnter = (pageId: string) => {
  if (!pageId) {
    return false
  }
  return NOT_AUTO_TO_LIST?.includes(pageId)
}

export default cusPageEnter
